// extracted by mini-css-extract-plugin
export default {"account":"AccountId_account__x5U2n"};